export default __webpack_public_path__ + "static/devops-6e7bc1e800dc9d4723cd853db2e0fc6e.png";